<div class="modal fade representante-popula-modal" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    {{title}}
                </h4>    
                <h6 class="modal-subtitle mb-0">
                    {{subtitle}}
                </h6>    
            </div>
            <div class="modal-body">
               <form #form="ngForm" novalidate>
                    <sgt-loading-info
                        *ngIf="isLoading"
                        title="Carregando os representantes"
                        text="Aguarde um momento enquanto estamos carregando os representantes">
                    </sgt-loading-info> 

                    <ng-template [ngIf]="isLoadingFinished">
                        <div class="table-responsive" *ngIf="hasEntities()">
                            <table class="table table-striped table-hover" [id]="idDataTable">
                                <thead>
                                    <tr>
                                        <th class="col-select text-center">
                                            <div class="custom-control custom-switch" *ngIf="hasEntities()">
                                                <input type="checkbox" class="custom-control-input" [(ngModel)]="allSelected" name="allSelected" id="allSelected"
                                                    (ngModelChange)="onChangeAllSelected($event)">
                                                <label class="custom-control-label" for="allSelected"></label>
                                            </div>
                                        </th>
                                        <th class="col-codigo-integracao">Código</th>
                                        <th class="col-nome">Nome</th>
                                        <th class="col-fantasia">Fantasia</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let entityPopula of entitiesPopula; let index = index"
                                        [class.exists]="entityPopula.exists">
                                        <td class="col-select text-center">
                                            <div class="custom-control custom-switch" *ngIf="!entityPopula.exists">
                                                <input type="checkbox" class="custom-control-input" [(ngModel)]="entityPopula.selected" name="entityPopulaSelected_{{index}}" id="entityPopulaSelected_{{index}}"
                                                   (ngModelChange)="onChangeSelected()">
                                                <label class="custom-control-label" for="entityPopulaSelected_{{index}}"></label>
                                            </div>                                      
                                        </td>
                                        <td class="col-codigo-integracao">
                                            {{entityPopula.representante?.pessoa.codigoIntegracaoErp}}
                                        </td>
                                        <td class="col-nome">
                                            {{entityPopula.representante?.pessoa?.nome}}
                                        </td>
                                        <td class="col-fantasia">
                                            {{entityPopula.representante?.pessoa?.nomeFantasia}}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>                        
                              
                        <div class="alert alert-info alert-no-entities" *ngIf="!hasEntities()">
                             <h5>
                                <i class="fas fa-info" aria-hidden="true"></i> Nenhum representante encontrado
                             </h5>
                             <p>É necessário cadastrar ou ativar os representantes para poder adicionar</p>
                         </div>
                    </ng-template>            
               </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-light mr-2" (click)="close()">
                    Cancelar
                </button>
                <button type="button" class="btn btn-primary" (click)="popularClick()" id="btnPopularUnidadeNegocioPopulaModal" *ngIf="hasEntities()">
                    Adicionar
                </button>
            </div>            
        </div>
    </div>
</div>